import { Dispatch } from 'redux'

import collegeGuidanceNetworkService from 'common/college-guidance-network-service'

import types from './types'

const dispatchedFetchIntegration = (dispatch: Dispatch<types>) => {
  dispatch({ type: 'FETCH_COLLEGE_GUIDANCE_NETWORK_START' })
  return collegeGuidanceNetworkService
    .getCollegeGuidanceNetworkIntegration()
    .then((integration) => {
      dispatch({
        type: 'FETCH_COLLEGE_GUIDANCE_NETWORK_SUCCESS',
        payload: integration,
      })
    })
    .catch(() => dispatch({ type: 'FETCH_COLLEGE_GUIDANCE_NETWORK_FAILURE' }))
}

const fetchCollegeGuidanceNetworkIntegration = () => {
  return dispatchedFetchIntegration
}

const hideBanner = () => {
  return async (dispatch: Dispatch<types>) => {
    dispatch({
      type: 'UPDATE_COLLEGE_GUIDANCE_NETWORK_BANNER_START',
    })

    try {
      await collegeGuidanceNetworkService.setCollegeGuidanceNetworkIntegration({ HideBanner: true })
      dispatch({
        type: 'UPDATE_COLLEGE_GUIDANCE_NETWORK_BANNER_SUCCESS',
      })
    } catch {
      dispatch({ type: 'UPDATE_COLLEGE_GUIDANCE_NETWORK_BANNER_FAILURE' })
    }

    await dispatchedFetchIntegration(dispatch)
  }
}

export default {
  fetchCollegeGuidanceNetworkIntegration,
  hideBanner,
}
